import { applySnapshot, getSnapshot } from 'mobx-state-tree';
import dayjs from 'dayjs';

const MAX_CART_VALIDITY_MINUTES = 5;
const CART_KEY = '__checkout';
const GIFT_CART_KEY = '__gift-card-checkout';

const persistGiftCardCart = (rootStore, orderInput) => {
  const { CartStore, FeatureFlagStore, PaymentStore } = rootStore;
  const storedAt = Date.now();
  const snapshots = {
    cart: getSnapshot(CartStore),
    payment: getSnapshot(PaymentStore),
    featureFlags: getSnapshot(FeatureFlagStore),
    storedAt,
    orderInput,
  };

  window.sessionStorage.setItem(GIFT_CART_KEY, JSON.stringify(snapshots));
};

const restoreGiftCardCart = rootStore => {
  const { CartStore, FeatureFlagStore, PaymentStore } = rootStore;
  const storedSnapshots = window.sessionStorage.getItem(GIFT_CART_KEY);

  if (!storedSnapshots) {
    return null;
  }

  const parsedSnapshots = JSON.parse(storedSnapshots);

  const { cart, featureFlags, payment, storedAt, orderInput } = parsedSnapshots;

  if (dayjs().diff(dayjs(storedAt), 'minutes') >= MAX_CART_VALIDITY_MINUTES) {
    return null;
  }

  applySnapshot(CartStore, cart);
  applySnapshot(PaymentStore, payment);
  applySnapshot(FeatureFlagStore, featureFlags);

  return orderInput;
};

const persistCart = rootStore => {
  const { CartStore, DeliveryStore, FeatureFlagStore, PaymentStore, OrderStore } = rootStore;
  const storedAt = Date.now();
  const snapshots = {
    cart: getSnapshot(CartStore),
    delivery: getSnapshot(DeliveryStore),
    payment: getSnapshot(PaymentStore),
    featureFlags: getSnapshot(FeatureFlagStore),
    storedAt,
    payableTotal: OrderStore.payableTotal,
  };

  window.sessionStorage.setItem(CART_KEY, JSON.stringify(snapshots));
};

const getSessionStorageSnapshot = () => {
  const sessionSnapshot = window.sessionStorage.getItem(CART_KEY);
  return sessionSnapshot ? JSON.parse(sessionSnapshot) : undefined;
};

const restoreCart = rootStore => {
  const { CartStore, DeliveryStore, FeatureFlagStore, PaymentStore } = rootStore;

  const sessionSnapshot = getSessionStorageSnapshot();

  if (!sessionSnapshot) {
    return;
  }
  const { cart, delivery, featureFlags, payment, storedAt } = sessionSnapshot;

  if (dayjs().diff(dayjs(storedAt), 'minutes') >= MAX_CART_VALIDITY_MINUTES) {
    return;
  }

  applySnapshot(CartStore, cart);
  applySnapshot(DeliveryStore, delivery);
  applySnapshot(PaymentStore, payment);
  applySnapshot(FeatureFlagStore, featureFlags);
};

const clearPersistedCartData = () => {
  window.sessionStorage.removeItem(CART_KEY);
};

const clearPersistedGiftCartData = () => {
  window.sessionStorage.removeItem(GIFT_CART_KEY);
};

export {
  persistCart,
  restoreCart,
  getSessionStorageSnapshot,
  clearPersistedCartData,
  persistGiftCardCart,
  restoreGiftCardCart,
  clearPersistedGiftCartData,
  CART_KEY,
};
